import styles from "./TreatmentsBlock.module.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import treatmentPrev from "../../assets/images/rhinoplasty-surgery-hor.png";
import treatmentPrevHigh from "../../assets/images/rhinoplasty-surgery-ver.png";
import treatment1 from "../../assets/images/auto.webp";
import treatment2 from "../../assets/images/rhinoplasty2.webp";
import treatment3 from "../../assets/images/sapphire-fue.webp";
import treatment4 from "../../assets/images/dhi-hair.webp";

export default function TreatmentsBlock() {
  const navigate = useNavigate()
  const thumbs = [treatment1, treatment2, treatment3, treatment4]
  const labels = [
    "Autologous Micrograft",
    "Rhinoplasty",
    "Sapphire FUE Hair Transplant",
    "DHI Hair Transplant",
  ]
  const paths = [
    "/autologous-micrograft",
    "/rhinoplasty",
    "/sapphire-fue-hair-transplant",
    "/dhi-hair-transplant",
  ]
  const [bgSrc, setBgSrc] = useState(() =>
    typeof window !== "undefined" && window.innerWidth <= 560 ? treatmentPrevHigh : treatmentPrev
  )

  useEffect(() => {
    const onResize = () => {
      const isSmall = window.innerWidth <= 560
      setBgSrc(isSmall ? treatmentPrevHigh : treatmentPrev)
    }
    window.addEventListener("resize", onResize)
    return () => window.removeEventListener("resize", onResize)
  }, [])
  return (
    <section className="section black">
      <div className="container">
        <div
          className={styles.treatmentsSection}
          style={{ backgroundImage: `url(${bgSrc})` }}
        >
          <div className={styles.headingWrap}>
            <h2 style={{ fontSize: "40px" }}>
              <span style={{ color: "#dbe7ff" }}>Discover Our </span>
              <span style={{ color: "#34e4e1" }}>Advanced Treatments</span>
            </h2>
            <p>
              <span className={styles.descLine1}>We harness the power of innovation and superior medical science </span>
              <span className={styles.descLine2}>to significantly enhance our patients' lives.</span>
            </p>
          </div>
          <div className={styles.thumbCard}>
            <div className={styles.treatmentsThumbs}>
              {thumbs.map((src, i) => (
                <figure 
                  key={i} 
                  className={styles.thumbItem}
                  onClick={() => {
                    navigate(paths[i]);
                    window.scrollTo(0, 0);
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  <img src={src || "/placeholder.svg"} alt={labels[i] || `Treatment ${i + 1}`} />
                  <figcaption className={styles.thumbCaption}>{labels[i]}</figcaption>
                </figure>
              ))}
            </div>
            <div className={styles.ctaWrap}>
              <a href="/results" className={styles.ctaBtn}>SEE ALL TREATMENT RESULTS</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
